import { object, optional, parse, string } from 'valibot'
import { pageSchema } from '~/utils/solr/literature'
import { createSolrResponseSchema } from '~/utils/solr/schemas'

// Like pageSchema but bodytext is optional — unlicensed users get metadata-only fields
const pageMetadataSchema = object({
  ...pageSchema.entries,
  bodytext: optional(string()),
})

export function useFetchBookPage({ id, sort = 'pageNumber desc', rows = '1' }: { id: string, sort?: string, rows?: string }) {
  const params = { id, sort, rows }

  return useQuery({
    queryKey: ['book-page', params],
    queryFn: async ({ signal }) =>
      await $fetch<unknown>(`/api/solr/literature/page`, { params, signal }),
    select: (res) => {
      const responseSchema = createSolrResponseSchema(pageMetadataSchema)
      return parse(responseSchema, res)
    },
  })
}
